import { Checkbox, Typography } from '@mui/material';
import { CompanyRole } from 'constants/CompanyRole';
import { useCallback } from 'react';
import { useAppSelector } from 'store';
import { profileSelector } from 'store/selectors/profile-selectors';
import { DayOfWeek, HeaderCell, NumberOfItems } from '../styles';
import { IGridHeaderCellProps } from '../types';

const GridHeaderCell = (props: IGridHeaderCellProps): JSX.Element => {
  const { dayOfWeek, date, numberOfItems, onCheckDay, checked, year } = props;
  const isEmployee = useAppSelector(profileSelector).role === CompanyRole.EMPLOYEE;

  const onClickCheckbox = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const newChecked = e.target.checked;
      onCheckDay(date, newChecked);
    },
    [date, onCheckDay],
  );

  const formatDate = (value: Date) => {
    const day = value.getDate();
    const m = value.toLocaleString('default', { month: 'short' });
    return `${day} ${m}`;
  };

  return (
    <HeaderCell
      highlight={
        new Date(date).getDate() === new Date(Date.now()).getDate() &&
        new Date(date).getMonth() === new Date(Date.now()).getMonth() &&
        year === new Date(Date.now()).getFullYear()
      }
    >
      <DayOfWeek>
        <Typography>
          <b>{dayOfWeek}</b> {formatDate(date)}
        </Typography>
        {!isEmployee && <Checkbox checked={checked || false} onChange={onClickCheckbox} />}
      </DayOfWeek>
      <NumberOfItems>{numberOfItems}</NumberOfItems>
    </HeaderCell>
  );
};

export default GridHeaderCell;
